import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useRevokeMembership } from '../queries';

type RevokeMembershipModalProps = {
  open: boolean;
  membershipUuid?: string;
  onClose: () => void;
};

const RevokeMembershipModal = ({ open, membershipUuid, onClose }: RevokeMembershipModalProps) => {
  const revokeMutation = useRevokeMembership();
  const [reason, setReason] = useState('');
  const [confirmText, setConfirmText] = useState('');
  const [error, setError] = useState('');

  if (!open) return null;

  const disabled = reason.trim().length < 5 || confirmText.trim() !== 'CONFIRM' || !membershipUuid;

  const handleRevoke = async () => {
    if (!membershipUuid) return;
    setError('');
    try {
      await revokeMutation.mutateAsync({ membershipUuid, reason: reason.trim() });
      onClose();
    } catch (_error) {
      setError('Unable to revoke membership right now.');
    }
  };

  return (
    <div className="membership-modal-overlay" onClick={onClose}>
      <div className="appointments-v2-card membership-modal-card" onClick={(event) => event.stopPropagation()}>
        <div className="appointments-v2-card-header"><h3>Revoke membership</h3></div>
        <div className="appointments-v2-card-body membership-drawer-panel__form">
          <div className="membership-modal-banner is-danger">
            <span className="membership-modal-banner__icon" aria-hidden="true"><AlertTriangle size={16} /></span>
            <span>This action will immediately revoke the membership. The customer will lose access to all tier benefits.</span>
          </div>
          <label className="field">
            <span className="label">Reason (min 5 chars)</span>
            <textarea className="input" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} />
          </label>
          <label className="field">
            <span className="label">Type CONFIRM to proceed</span>
            <input className="input" value={confirmText} onChange={(e) => setConfirmText(e.target.value)} />
          </label>
          {error ? <p className="appointments-v2-empty-copy">{error}</p> : null}
          <div className="membership-drawer-panel__actions">
            <button type="button" className="btn ghost" onClick={onClose}>Cancel</button>
            <button type="button" className="btn ghost danger" disabled={disabled || revokeMutation.isPending} onClick={handleRevoke}>
              {revokeMutation.isPending ? 'Revoking...' : 'Revoke'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevokeMembershipModal;
